import { render, staticRenderFns } from "./QuantityDropdown.vue?vue&type=template&id=54c565ea&scoped=true&"
import script from "./QuantityDropdown.vue?vue&type=script&lang=js&"
export * from "./QuantityDropdown.vue?vue&type=script&lang=js&"
import style0 from "./QuantityDropdown.vue?vue&type=style&index=0&id=54c565ea&scoped=true&lang=css&"
import style1 from "./QuantityDropdown.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c565ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
